import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

import SalesLineChart from "./SalesLineChart";
import VolumeSubtitle from "./VolumeSubtitle";

VolumeGraph.propTypes = {
    online: PropTypes.object,
    physical: PropTypes.object,
    onlineCountTotal: PropTypes.number,
    ordersData: PropTypes.object,
    unit: PropTypes.oneOf(["day", "month", "year"]).isRequired,
    unitParser: PropTypes.oneOf(["YYYY", "YYYYMM", "YYYYMMDD"]).isRequired,
    unitTooltip: PropTypes.oneOf(["YYYY", "MMMM YYYY", "D MMMM YYYY"]).isRequired,
    loading: PropTypes.bool,
}

function VolumeGraph({online, physical, onlineCountTotal, ordersData, unit, unitParser, unitTooltip, loading}) {
    const intl = useIntl();

    // Line item count across all statuses
    const productsSold = ordersData?.productsSold ?? 0;

    const volumeKpi = productsSold > 0 ? productsSold.toLocaleString() : null;


    return (
        <SalesLineChart
            title={''}
            kpiValue={volumeKpi}
            subtitle={<VolumeSubtitle productsSold={productsSold} totalOrders={onlineCountTotal} />}
            onlineData={online.countGraph}
            physicalData={physical.countGraph}
            onlineLegend={intl.formatMessage({ id: "dashboard.graph.legend.online" })}
            physicalLegend={intl.formatMessage({ id: "dashboard.graph.legend.physical" })}
            unit={unit}
            unitParser={unitParser}
            unitTooltip={unitTooltip}
            loading={loading}
        />
    );
}

export default VolumeGraph;
